<template>
  <div class="row q-col-gutter-md">
    <div class="col-12">
      <q-select
        v-model="dados.funcionario_id"
        dense
        clearable
        emit-value
        map-options
        label="Operador responsável"
        option-value="id"
        option-label="label"
        :options="negociosFuncionarios"
        :error="Boolean(erros.funcionario_id)"
        :error-message="primeiroErro('funcionario_id')"
      />
    </div>

    <div class="col-12 col-md-6">
      <q-input
        :model-value="dados.prazo"
        @update:model-value="dados.prazo = $numero($event)"
        dense
        clearable
        type="number"
        label="Prazo em parcelas"
        :error="Boolean(erros.prazo)"
        :error-message="primeiroErro('prazo')"
      />
    </div>

    <div class="col-12 col-md-6">
      <q-input
        :model-value="dados.taxa"
        @update:model-value="dados.taxa = $numero($event)"
        dense
        clearable
        type="number"
        step="0.0001"
        label="Taxa simulada (%)"
        :error="Boolean(erros.taxa)"
        :error-message="primeiroErro('taxa')"
      />
    </div>

    <div class="col-12 col-md-6">
      <q-field v-model="dados.valor_parcela" dense stack-label label="Valor da parcela">
        <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">
          <money-input
            :id="id"
            class="q-field__native text-right"
            :value="modelValue"
            v-bind="moneyFormat"
            v-show="floatingLabel"
            @input="emitValue"
          />
        </template>
      </q-field>
    </div>

    <div class="col-12 col-md-6">
      <q-input
        :model-value="dados.percentual_previsto"
        @update:model-value="dados.percentual_previsto = $numero($event)"
        dense
        clearable
        type="number"
        step="0.001"
        label="Percentual de comissão (%)"
        hint="Vem da linha e fica congelado nesta oportunidade"
        :error="Boolean(erros.percentual_previsto)"
        :error-message="primeiroErro('percentual_previsto')"
      />
    </div>

    <div class="col-12 col-md-6">
      <q-input
        v-model="dados.protocolo"
        dense
        clearable
        label="Protocolo do banco"
        :error="Boolean(erros.protocolo)"
        :error-message="primeiroErro('protocolo')"
      />
    </div>

    <div v-if="edicao" class="col-12 col-md-6">
      <negocios-campo-data
        label="Data de retorno"
        :value="dados.data_alerta"
        @input="dados.data_alerta = $event"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MoneyInput from "@/components/Utils/money-input.vue";
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-campos-simulacao",
  components: { MoneyInput },
  mixins: [negociosMixin],
  props: {
    dados: {
      type: Object,
      required: true
    },
    erros: {
      type: Object,
      default: () => ({})
    },
    edicao: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["negociosFuncionarios"])
  },
  methods: {
  }
};
</script>
